import { apiRequest } from './http';
import type {
  ApiItemResponse,
  RegisteredSchemaRecord,
  SchemaLifecycleState,
  StorePayloadRequest,
  StoredPayloadReference,
} from '../types/api';

type Query = Record<string, string | undefined>;

function queryString(query: Query = {}): string {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.set(key, value);
  });
  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export const schemasApi = {
  list: (query: Query = {}) => apiRequest<{ data: RegisteredSchemaRecord[] }>(`/schemas${queryString(query)}`),
  create: async (payload: Omit<RegisteredSchemaRecord, 'id' | 'lifecycleState' | 'createdAt' | 'updatedAt'>) =>
    (await apiRequest<ApiItemResponse<RegisteredSchemaRecord>>('/schemas', { method: 'POST', body: JSON.stringify(payload) })).data,
  transition: async (id: string, lifecycleState: SchemaLifecycleState, reason?: string) =>
    (await apiRequest<ApiItemResponse<RegisteredSchemaRecord>>(`/schemas/${id}/lifecycle`, {
      method: 'PATCH',
      body: JSON.stringify({ lifecycleState, reason }),
    })).data,
  storePayload: async (payload: StorePayloadRequest) =>
    (await apiRequest<ApiItemResponse<StoredPayloadReference>>('/payload-references', {
      method: 'POST',
      body: JSON.stringify(payload),
    })).data,
};
